{
	"accounts": "Účty",
	"invitations": "Pozvánky",
	"subscribeToFeedback": "Přihlaste se k odběru programu zpětné vazby",
	"notificationSettings": {
		"title": "Nastavení e-mailových oznámení",
		"invoicingInformation": "Fakturační informace",
		"declarationProcessingStatus": "Stav zpracování deklarace",
		"enabled": "Zap.",
		"disabled": "Vyp.",
		"toast": {
			"success": "Předvolba oznámení byla aktualizována",
			"error": "Nepodařilo se aktualizovat předvolbu oznámení"
		}
	},
	"about": {
		"title": "O aplikaci",
		"termsAndConditions": "Smluvní podmínky",
		"privacyPolicy": "Zásady ochrany osobních údajů",
		"imprint": "Otisk",
		"openSourceAttribution": "Open Source Atribuce"
	},
	"language": {
		"title": "Jazyk",
		"footer": "Změny jazyka se promítnou do všech aplikací Heidelberg Materials"
	},
	"impressum": "Otisk",
	"copyright": "© 2024 Heidelberg Materials. Všechna práva vyhrazena.",
	"login": "Přihlášení",
	"logout": "Odhlášení"
}
